import { Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material"
import Step01 from "./Step01"
import Step02 from "./Step02"
import { useFormContext } from "react-hook-form"
import InfoStep01 from "./Step01/InfoStep01"

export default function StepperIncluirLancamento() {

    const { watch } = useFormContext()

    const activeStep = watch('stepper')

    const steps: Array<ISteps> = [
        {
            label: "Dados do cheque",
            component: <Step01 />,
            info: <InfoStep01 />
        },
        {
            label: "Dados financeiros",
            component: <Step02 />,
            info: <></>
        }
    ]
    return (
        <Stepper activeStep={activeStep} orientation="vertical">
            {
                steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            sx={{ alignItems: 'flex-start' }}
                            optional={
                                index < activeStep ?
                                    <Box sx={{
                                        pl: 4,
                                        top: 8,
                                        left: -20,
                                        position: 'relative',
                                        borderLeft: "1px solid #bdbdbd",
                                    }}>
                                        {step.info}
                                    </Box>
                                    : null
                            }
                        >
                            <Typography marginBottom={2} color={activeStep === index ? '#000000' : 'rgba(0, 0, 0, 0.6)'} variant="subtitle1">{step.label}</Typography>
                        </StepLabel>
                        <StepContent>{step.component}</StepContent>
                    </Step>
                ))
            }

        </Stepper>
    )
}

type TStepperTitle = "Dados do cheque" | "Dados financeiros"

interface ISteps {
    label: TStepperTitle,
    component: React.ReactNode,
    info: React.ReactNode
}